import * as React from "react";
import { useContactLensProductData, useCLDeliveryIndicatorConfig } from "@grandvisionhq/fun-products";
import { useFeatureToggles, useIntl } from "@grandvisionhq/state";
import { DeliveryIndicatorLoader, DeliveryIndicator } from "@grandvisionhq/shipping";
const FullDateDeliveryIndicatorContainer = ({
  isExcludedFromCheckout,
  deliveryItems,
  hasRxLens,
  fallbackLabel,
  showLoader,
  className
}) => {
  const { isDeliveryFullDateEnabled } = useFeatureToggles();
  if (isExcludedFromCheckout || !deliveryItems || !isDeliveryFullDateEnabled) {
    return null;
  }
  if (showLoader) {
    return /* @__PURE__ */ React.createElement(DeliveryIndicatorLoader, null);
  }
  return /* @__PURE__ */ React.createElement(
    DeliveryIndicator,
    {
      view: "text",
      items: deliveryItems,
      hasRxLens,
      fallbackLabel,
      className
    }
  );
};
const FullDateDeliveryIndicatorCLContainer = ({ className }) => {
  const { getLabel } = useIntl();
  const { activeVariant } = useContactLensProductData();
  const { validLineItemDrafts } = useCLDeliveryIndicatorConfig();
  const fallbackLabel = getLabel("products.deliveryIndicator.selectPrescription");
  const deliveryItems = validLineItemDrafts?.map((lineItemDraft) => ({
    sku: lineItemDraft.sku,
    quantity: lineItemDraft.quantity || 1
  }));
  return /* @__PURE__ */ React.createElement(
    FullDateDeliveryIndicatorContainer,
    {
      className,
      fallbackLabel,
      deliveryItems,
      isExcludedFromCheckout: activeVariant.isExcludedFromCheckout
    }
  );
};
export {
  FullDateDeliveryIndicatorCLContainer,
  FullDateDeliveryIndicatorContainer
};
//# sourceMappingURL=FullDateDeliveryIndicatorContainer.js.map
